import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TableContentSupplierDairySummaryReport } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate, search } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { factoryItemStatusReportSchema } from "../factoryItemStatusReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'FACTORYITEMSTATUSREPORT'

export function FactoryItemStatusReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        itemCategoryID: "0",
        factoryItemID: "0",
        toDate: " ",
        fromDate: " ",
        statusID: "0"

    });

    const [errors, setErrors] = useState({});
    const schema = Joi.object(factoryItemStatusReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const initialContentRownames = ["createdDate", "registrationNumber",
        "collectionPointName", "categoryName", "factoryItemName" , "requestedQuantity" , "approvedQuantity", "totalPrice", "reason", "statusID"];
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });
    const [ItemCategoryList, setItemCategoryList] = useState();
    const [ItemList, setItemList] = useState();
    const initlaCsvHeaders = [
        { label: "Date", value: "createdDate" },
        { label: "Reg No", value: "registrationNumber" },
        { label: "Collection PointName", value: "categoryName" },
        { label: "Item Category", value: "categoryName" },
        { label: "Item Name", value: "factoryItemName" },
        { label: "Requested Quantity", value: "requestedQuantity" },
        { label: "Approved Quantity", value: "approvedQuantity" },
        { label: "Total Price", value: "totalPrice" },
        { label: "Reason", value: "reason" },
        { label: "Status", value: "statusID" },
    ];

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown(),
            getAllActiveItemCategory()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])
    useEffect(() => {
        trackPromise(
            getFactoryItemsByFactoryIDItemCategory()
        )
    }, [searchData.itemCategoryID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMSTATUSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }
    async function getAllActiveItemCategory() {
        const result = await service.getAllActiveItemCategory();
        setItemCategoryList(result);
      }

      async function getFactoryItemsByFactoryIDItemCategory() {
        const result = await service.GetFactoryItemsByFactoryIDItemCategory(searchData.operationEntityID,searchData.itemCategoryID);
        setItemList(result);
      }
      

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, factoryItemStatusReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        setSelectedSearchData(searchData);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetTotalFactoryItemStatusReport(searchData.operationEntityID,
             searchData.collectionPointID, searchData.itemCategoryID, searchData.factoryItemID, searchData.toDate, searchData.fromDate, searchData.statusID);
            reportData.forEach(x => {
                x.createdDate = x.createdDate.split('T')[0];
                x.totalPrice = x.totalPrice.toFixed(2);
                x.statusID =  x.statusID === 1 ? "new" : x.statusID === 2 ? "Approved" : (x.statusID === 3 ? "Rejected" : "Delivered");
            })
        

        
        setReportData(reportData);
        setIsTableHide(false);
        createDataTable(["#totalCrop", "#totalCropPdf"]);

    }


    function generateCsvData(data) {

        var newRecord = {};
        var copyOfRecords = _.cloneDeep(data.result);

        newRecord.weightReadTime = "Total";
        data.totalResult.forEach(x => {
            newRecord[x.name] = x.value
        });

        copyOfRecords.push(newRecord);

        setCsvData(copyOfRecords);
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var totalRow = [];

        data.forEach(x => {
            var collectionTypeName = (x.collectionTypeName);

            if (result.length === 0) {
                result.push({
                    collectionPointName: x.collectionPointName,
                    [collectionTypeName]: parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount),
                    total: parseFloat(x.grossAmount),
                    weightReadTime: x.weightReadTime.split("T")[0],
                });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.grossAmount);
                totalRow.push({ name: x.collectionTypeName, value: parseFloat(x.grossAmount).toFixed(2) });
            } else {
                var duplicateDate = result.find(y => (y.weightReadTime) === (x.weightReadTime.split("T")[0])
                    && y.collectionPointName === x.collectionPointName);
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.grossAmount);

                var duplicateTotalRowData = totalRow.find(y => y.name === x.collectionTypeName);

                if (duplicateTotalRowData) {
                    duplicateTotalRowData.value = (parseFloat(duplicateTotalRowData.value) + parseFloat(x.grossAmount)).toFixed(2);
                } else {
                    totalRow.push({ name: x.collectionTypeName, value: parseFloat(x.grossAmount).toFixed(2) });
                }

                if (duplicateDate) {
                    duplicateDate[collectionTypeName] = parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount);
                    duplicateDate.total = parseFloat(duplicateDate.total) + parseFloat(x.grossAmount);
                } else {
                    result.push({
                        collectionPointName: x.collectionPointName,
                        [collectionTypeName]: parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount),
                        total: parseFloat(x.grossAmount),
                        weightReadTime: x.weightReadTime.split("T")[0],
                    });
                }
            }
        });

        totalRow.push({ name: "total", value: totalOfAllrecords.toFixed(2) });

        setAllTotal(totalRow);

        return {
            result: result,
            totalResult: totalRow
        };
    }
    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                order: [[1, "asc"]],
                destroy: x === '#totalCropPdf' ? true : false,
                searching: x === '#totalCropPdf' ? false : true,
                paging: x === '#totalCropPdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < contentResult.length; ++i) {
                            if (i > 1) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        var calResult = checkUndifined(a) + checkUndifined(b) * 1
                                        return calResult;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < contentResult.length; ++i) {
                            if (i > 1) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            }
                        }


                        return $('<tr/>')
                            .append('<td colspan="2"><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            fromDate: searchData.fromDate,
            toDate: searchData.toDate,
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Factory Item Status Report',
            fileName: 'Factory Item Status Report',
            writeOptions: {}
        }

        xlsx(initlaCsvHeaders, reportData, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Factory Item Status Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="itemCategoryID">Item Catagory </InputLabel>
                                    <Select
                                        fullWidth
                                        id="itemCategoryID"
                                        name="itemCategoryID"
                                        value={searchData.itemCategoryID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Item Catagory--</MenuItem>
                                        {generateDropDownMenu(ItemCategoryList)}
                                    </Select>
                                    {errors["itemCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["itemCategoryID"]}</FormHelperText>}
                                </div>
                                </div>
                                <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="factoryItemID">Factory Items </InputLabel>
                                    <Select
                                        fullWidth
                                        id="factoryItemID"
                                        name="factoryItemID"
                                        value={searchData.factoryItemID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory Items--</MenuItem>
                                        {generateDropDownMenu(ItemList)}
                                    </Select>
                                    {errors["factoryItemID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryItemID"]}</FormHelperText>}
                                </div>

                                <div className="col-md">
                                    <InputLabel shrink id="fromDate">
                                        From Date *
                                    </InputLabel>
                                    <TextField
                                        fullWidth
                                        id="fromDate"
                                        name="fromDate"
                                        value={searchData.fromDate}
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["fromDate"] && (
                                        <FormHelperText
                                            id="errbranchCode"
                                            className="text text-danger"
                                        >
                                            {errors["fromDate"]}
                                        </FormHelperText>
                                    )}
                                </div>

                                <div className="col-md">
                                    <InputLabel shrink id="toDate">
                                        To Date *
                                    </InputLabel>
                                    <TextField
                                        fullWidth
                                        id="toDate"
                                        name="toDate"
                                        value={searchData.toDate}
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["toDate"] && (
                                        <FormHelperText
                                            id="errbranchCode"
                                            className="text text-danger"
                                        >
                                            {errors["toDate"]}
                                        </FormHelperText>
                                    )}
                                </div>

                                <div className="col-md">
                                        <TextField select fullWidth
                                            label="Status "
                                            id="statusID"
                                            name="statusID"
                                            value={searchData.statusID}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Status--</option>
                                            <option value="1">New</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                            <option value="4">Delivered</option>
                                        </TextField>
                                    </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            <Grid item md={12} xs={12}>
                                <table id="reportTable">
                                    <thead>
                                        <tr>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Date</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Reg No</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Collection Point</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Item Catogory</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Item Name</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Requested Quentity</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Approved Quentity</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Total Price</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Reason</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <TableContentSupplierDairySummaryReport
                                                data={reportData}
                                                contentRowNames={initialContentRownames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                    
                                </table>
                            </Grid>
                            {/* } */}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Factory Item Status Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={initialContentRownames}
                                            searchData={selectedSearchValues} totalRow={allTotal} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



